// extracted by mini-css-extract-plugin
module.exports = {"wrap":"general_wrap__1ZKGV breakPointM-height-100 breakPointM-width-100"};